import React, { useState, useEffect } from "react";
import axios from "axios";
import { VerticalGraph } from "./VerticalGraph";
import { DataCard, DataCardList } from "./DataCard";
import { API_BASE_URL } from "../config/urls";

const Holdings = () => {
  const [allHoldings, setAllHoldings] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`${API_BASE_URL}/allHoldings`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setAllHoldings(res.data));
  }, []);

  const labels = allHoldings.map((stock) => stock.name);
  const data = {
    labels,
    datasets: [
      {
        label: "stock price",
        data: allHoldings.map((stock) => stock.price),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };

  return (
    <>
      <h3 className="title">Holdings ({allHoldings.length})</h3>

      <div className="order-table table-desktop">
        <table>
          <thead>
            <tr>
              <th>Instrument</th>
              <th>Qty.</th>
              <th>Avg. cost</th>
              <th>LTP</th>
              <th>Cur. val</th>
              <th>P&L</th>
              <th>Net chg.</th>
              <th>Day chg.</th>
            </tr>
          </thead>
          <tbody>
            {allHoldings.map((stock, index) => {
              const currValue = stock.price * stock.qty;
              const isProfit = currValue - stock.avg * stock.qty >= 0.0;
              const profClass = isProfit ? "profit" : "loss";
              const dayClass = stock.isLoss ? "loss" : "profit";

              return (
                <tr key={index}>
                  <td>{stock.name}</td>
                  <td>{stock.qty}</td>
                  <td>{stock.avg.toFixed(2)}</td>
                  <td>{stock.price.toFixed(2)}</td>
                  <td>{currValue.toFixed(2)}</td>
                  <td className={profClass}>
                    {(currValue - stock.avg * stock.qty).toFixed(2)}
                  </td>
                  <td className={profClass}>{stock.net}</td>
                  <td className={dayClass}>{stock.day}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <DataCardList emptyMessage="No holdings yet.">
        {allHoldings.map((stock, index) => {
          const currValue = stock.price * stock.qty;
          const pnl = currValue - stock.avg * stock.qty;
          const isProfit = pnl >= 0;
          const profClass = isProfit ? "profit" : "loss";
          const dayClass = stock.isLoss ? "loss" : "profit";

          return (
            <DataCard
              key={index}
              title={stock.name}
              subtitle={`Qty: ${stock.qty}`}
              badge={`${isProfit ? "+" : ""}${pnl.toFixed(2)}`}
              badgeClass={profClass}
              rows={[
                { label: "Avg. cost", value: stock.avg.toFixed(2) },
                { label: "LTP", value: stock.price.toFixed(2) },
                { label: "Current value", value: currValue.toFixed(2) },
                { label: "Net chg.", value: stock.net, valueClass: profClass },
                { label: "Day chg.", value: stock.day, valueClass: dayClass },
              ]}
            />
          );
        })}
      </DataCardList>

      <div className="row">
        <div className="col">
          <h5>
            29,875.<span>55</span>{" "}
          </h5>
          <p>Total investment</p>
        </div>
        <div className="col">
          <h5>
            31,428.<span>95</span>{" "}
          </h5>
          <p>Current value</p>
        </div>
        <div className="col">
          <h5>1,553.40 (+5.20%)</h5>
          <p>P&L</p>
        </div>
      </div>
      <VerticalGraph data={data} />
    </>
  );
};

export default Holdings;
